import {ACTIVE_TRANSPORTER_PARAM} from 'common/active-transporter';
import React from 'react';
import {Typography} from 'antd';
import useUserGroups from 'hooks/useUserGroups';
import {PersonDeletionImpact} from './operation';

/** Location details are supplied only for POBs owned by the signed-in organization. */
export default function PobLink({navigation}: {navigation: NonNullable<PersonDeletionImpact['pobNavigation']>}) {
    const [groups] = useUserGroups();
    const label = 'Fix in Quartermaster';
    if (!groups.includes('flytsuite.quartermaster')) {
        return <Typography.Text disabled title="Quartermaster permission is required.">{label}</Typography.Text>;
    }
    const params = new URLSearchParams({location: navigation.locationID, search: navigation.search, guidance: 'depart-pob', highlightPobID: navigation.pobID});
    if (navigation.transitID) params.set('transit', navigation.transitID);
    if (navigation.transporterID) params.set(ACTIVE_TRANSPORTER_PARAM, navigation.transporterID);
    return <a href={`/app/quartermaster?${params}`} target="_blank" rel="noopener noreferrer">{label}</a>;
}
